export default __webpack_public_path__ + "static/media/ten-companies.de745792.svg";